import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonCTAProps {
  text: string;
  href?: string;
  className?: string;
}
export function ButtonCTA({
  text,
  href = 'https://prismamethods.com/cart/46348520784071:1',
  className = ''
}: ButtonCTAProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-2 px-8 py-4 text-lg md:text-xl font-bold text-slate-900 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-full shadow-[0_0_15px_rgba(245,158,11,0.3)] hover:shadow-[0_0_25px_rgba(245,158,11,0.6)] hover:scale-105 transition-all duration-300 ${className}`} data-id="element-1">
      {text}
      <ArrowRightIcon className="w-6 h-6" data-id="element-2" />
    </a>;
}